"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asciiLogo = `  _____  _______ _______  _____  _______ __   __ _______
 |     | |______ |  |  | |     | |______   \\_/   |______
 |_____| ______| |  |  | |_____| \\______|    |    ______|`;
//# sourceMappingURL=asciiLogo.js.map